// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"751":"659d012b","787":"fdaafdcb"}[chunkId] + ".chunk.js";
};